import { es as coreEs } from '@account-services-mfe/core';
const es = {
    translation: {
        ...coreEs.translation,
        alreadyEnrolled: {
            header: {
                title: 'Ha adquirido Payment Security'
            },
            howCanICancel: {
                body: 'Payment Security es opcional y puede cancelar en cualquier momento <managePaymentSecurityLink>{{linkText}}</managePaymentSecurityLink> o llamando al 800-815-4051.',
                linkText: 'administrando Payment Security',
                title: '¿Como puedo cancelar?'
            }
        },
        cancelled: {
            errorMessage: {
                description: 'Aún puede usar sus beneficios de Payment Security siempre y cuando el evento calificado haya ocurrido antes de su cancelación.',
                title: 'Ha cancelado Payment Security'
            },
            header: {
                title: 'Con Payment Security, protéjase en caso de que ocurra un evento inesperado'
            }
        },
        common: {
            agreementCheck: 'Sí, deseo <strong>adquirir el producto opcional</strong> Payment Security. He leído y acepto los términos del Acuerdo de Programa de Cancelación de Deudas de Payment Security. Al marcar esta casilla, calificará como mi firma electrónica.',
            coverageAfterSignupDate: 'Está cubierto de inmediato para la mayoría de los eventos que califican, siempre y cuando ocurran después de la fecha de compra. En caso de pérdida del empleo o licencia, la cobertura comienza 30 días después de la compra.',
            coverMinimumPayments: 'Payment Security puede cubrir sus pagos mínimos o la totalidad de su saldo de crédito hasta $10,000 luego de determinados eventos de la vida.',
            disability: 'Discapacidad',
            header: {
                subtitle: 'El saldo de su cuenta de hasta $10,000 puede cancelarse.'
            },
            hospitalization: 'Hospitalización',
            howMuchItCosts: 'Costos',
            lastStatementBalance: '$1.66 cada $100 de su último estatus de cuenta. Por ejemplo, si tuvo un saldo de $500, debe pagar $8.30.',
            leaveOfAbsence: 'Permiso de ausencia',
            lossOfLife: 'Fallecimiento',
            nursingHomeStay: 'Estadía en un hogar de ancianos',
            paymentCancellationAndRefund: 'Es opcional y puede cancelarlo en cualquier momento. Si cancela dentro de 90 días, le brindaremos un reembolso por las tarifas de Payment Security que haya pagado hasta el momento.',
            paymentSecurityCancellationAgreement: 'Lea el <cancellationAgreementLink>{{cancellationAgreementText}}</cancellationAgreementLink>.',
            cancellationAgreementText: 'Acuerdo del Programa de Cancelación de Deudas de Payment Security',
            paymentSecurityDetails: 'Detalles de Payment Security',
            qualifiesAsAnEvent: 'Qué se considera un evento',
            unemployment: 'Desempleo',
            whatItProvides: 'Qué ofrece'
        },
        deniedEnrollment: {
            title: 'No puede comprar Payment Security en este momento'
        },
        enrollmentSuccess: {
            chargesStatement: 'Verá los cargos de Payment Security a partir de su próximo estado de cuenta. Usted podrá cancelarlo en cualquier momento. Si cancela dentro de los 90 días, acreditaremos a su cuenta cualquier tarifa de Payment Security que se hubiera cargado.',
            requestOnProcess: 'Estamos procesando su solicitud, lo cual puede demorar hasta 72 horas.',
            thanksForPurchasing: 'Gracias por comprar Payment Security'
        },
        errorMessages: {
            termsAgreement: 'Marque la casilla para aceptar estos términos y continuar'
        },
        footer: {
            backToAccountServices: 'Regresar a Servicios de Cuenta',
            close: 'cerrar',
            managePaymentSecurity: 'Administrar Payment Security',
            purchasePaymentSecurity: 'compre payment security'
        },
        notEnrolled: {
            header: {
                title: 'Con Payment Security, protéjase en caso de que ocurra un evento inesperado'
            },
            whatToKnow: {
                authorize: 'Usted autoriza que los costos del programa, calculados en $1.66 por cada $100 del saldo de su último estado de cuenta, se facturen a su cuenta cada mes, con vigencia inmediata.',
                beginAfter: 'Todos los eventos deben comenzar después de que se inscriba en el programa; por pérdida del trabajo o permiso de ausencia, debía haber estado inscrito desde 30 días antes de que ocurra.',
                cancelAnytime: 'Usted puede cancelar en cualquier momento. Si cancela dentro de los 90 días, recibirá un reembolso total.',
                fullTime: 'Debe tener un trabajo de tiempo completo y de todo el año para calificar para la cancelación total del saldo.',
                jobLossAndLeave: 'Los beneficios por pérdida de trabajo y permiso de ausencia dependen de su tipo de trabajo:',
                partTime: 'Los trabajos temporales o de tiempo parcial solo califican para la cancelación de hasta 6 meses de pagos mínimos.',
                title: 'Qué Debe Saber',
                understandProgramFee: 'Comprende que la tarifa del programa aparecerá en su estado de cuenta todos los meses y se le cargará aunque usted pague la totalidad del saldo de su estado de cuenta.'
            }
        },
        pendingEnrollment: {
            paymentRequestReceived: 'Recibimos su solicitud de Payment Security',
            statusUpdate: 'Su estatus será actualizado dentro de 3 días.'
        },
        crossBorder: {
            title: 'Abriendo una nueva pestaña del navegador',
            body: 'Estamos abriendo una nueva pestaña donde podrá administrar sus beneficios de Payment Security.',
            openNewTabButton: 'Sí, abrir en una nueva pestaña',
            goBackButton: 'No, volver'
        }
    }
};
export default es;
